export default function SearchIcon(props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      {...props}
      fill={props.fill || "#6CB6E3"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.3737 19.9596L15.7899 14.376C16.9618 12.8978 17.6667 11.0327 17.6667 9C17.6667 4.21354 13.7864 0.333336 8.99999 0.333336C4.21353 0.333336 0.333328 4.21354 0.333328 9C0.333328 13.7865 4.21353 17.6667 8.99999 17.6667C11.0327 17.6667 12.8979 16.9619 14.3759 15.79L19.9596 21.3737C20.1549 21.569 20.4108 21.6667 20.6667 21.6667C20.9225 21.6667 21.1784 21.569 21.3737 21.3737C21.7643 20.9831 21.7643 20.3502 21.3737 19.9596ZM2.33333 9C2.33333 5.32404 5.32395 2.33333 8.99999 2.33333C12.676 2.33333 15.6667 5.32404 15.6667 9C15.6667 12.676 12.676 15.6667 8.99999 15.6667C5.32395 15.6667 2.33333 12.676 2.33333 9Z" />
    </svg>
  )
}
